// Vendors
import $ from "jquery";
import "bootstrap";
import moment from "moment";
import _ from "underscore";
import "clndr";
import "slick-carousel";
import "simpleweather";

// Polyfill for fetch on mobile
import "whatwg-fetch";

// Setup sentry
Raven.config(
  "https://70f24eea7d484ea491b77aeab09ce1c8@sentry.io/243719"
).install();

// Display/hide the navbar on scroll
import stickyNav from "./sticky-nav";
stickyNav();

// Init carousels for staff and testimonials
import carousel from "./carousel";
carousel();

// Display/hide the navbar on scroll
import announcement from "./announcement";
announcement();

// Handle the instagram feed
//import instagram from "./instagram";
//instagram();

// Handle the calendar
import calendar from "./calendar";
calendar();

// Handle the payment tunnel
import "./tunnel";

// Handle the graph with dots
import productsGraph from "./products-graph";
productsGraph();

// Ticket printing
import ticket from "./ticket";
ticket();

// Footer minimap
import initMap from "./map";
window.initMap = initMap; // So that google can callback the function

// Facebook messenger button
import initFB from "./facebook";
initFB();

import "./products";

// Initialise tooltips
$('[data-toggle="tooltip"]').tooltip();

// Discover buttons
$(".btn-discover").click(function(e) {
  e.preventDefault();
  $("html, body").animate(
    {
      scrollTop: $("#jumps").offset().top
    },
    "slow"
  );
  return false;
});
